import React, { useState } from "react";
import { StatCard, MetaCell, Expandable, DataTable, SectionTitle, LastSynced, EmptyState } from "./DashboardPrimitives";

const OdooDashboard = ({ data, formatLastConnected }) => {
  const [openCompany, setOpenCompany] = useState(null);

  if (!data?.connector_data) return <EmptyState message="No Odoo data available" />;

  const { user, companies, installed_modules, employees, models_count, models_sample } = data.connector_data;

  return (
    <div className="space-y-6">
      {/* Identity strip */}
      <div className="pb-4 border-b border-gray-100">
        <p className="text-sm font-semibold text-gray-800">{user?.name || "User"}</p>
        <p className="text-xs text-gray-400">{user?.email} · Login: {user?.login}</p>
        <LastSynced value={data?.last_synced_at} formatFn={formatLastConnected} />
      </div>

      {/* Snapshot */}
      <div>
        <SectionTitle title="System Snapshot" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          <StatCard label="User ID" value={user?.id || "—"} />
          <StatCard label="Companies" value={companies?.length || 0} />
          <StatCard label="Employees" value={employees?.length || 0} />
          <StatCard label="Total Models" value={models_count || 0} />
        </div>
      </div>

      {/* Companies */}
      {companies?.length > 0 && (
        <div className="space-y-3">
          <SectionTitle title="Companies" count={companies.length} />
          {companies.map((company) => (
            <Expandable
              key={company.id}
              title={company.name}
              isOpen={openCompany === company.id}
              onToggle={() => setOpenCompany(openCompany === company.id ? null : company.id)}
              badge={<span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 font-medium">ID: {company.id}</span>}
            >
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <MetaCell label="Name" value={company.name} />
                <MetaCell label="Email" value={company.email} />
                <MetaCell label="Phone" value={company.phone || "—"} />
                {company.website && <MetaCell label="Website" value={company.website} />}
              </div>
            </Expandable>
          ))}
        </div>
      )}

      {/* Employees */}
      {employees?.length > 0 && (
        <div>
          <SectionTitle title="Employees" count={employees.length} />
          <DataTable
            headers={["Employee Name", "Work Email", "Job Title", "Work Phone"]}
            rows={employees.map((emp) => [emp.name || "—", emp.work_email || "—", emp.job_title || "—", emp.work_phone || "—"])}
          />
        </div>
      )}

      {/* Installed Modules */}
      {installed_modules?.length > 0 && (
        <div>
          <SectionTitle title="Installed Modules" count={installed_modules.length} />
          <DataTable
            headers={["Module Name", "Author", "Module ID"]}
            rows={installed_modules.map((m) => [m.name, m.author, m.id])}
          />
        </div>
      )}

      {/* Models Sample */}
      {models_sample?.length > 0 && (
        <div>
          <SectionTitle title={`Models Sample (${models_sample.length} of ${models_count})`} />
          <DataTable headers={["Model Name", "Model ID"]} rows={models_sample.map((m) => [m.name, m.model])} />
        </div>
      )}
    </div>
  );
};

export default OdooDashboard;
